module.exports = __webpack_public_path__ + "static/media/info.e56a68b3.svg";